<template>
  <div class="h-screen flex flex-col items-center justify-center text-center px-10">
    <div class="shadow-lg p-6 bg-white rounded-2xl flex flex-col items-center justify-center text-center py-10">
      <h1 class="text-4xl font-semibold text-gray-700 mb-6">Student Graduation In Progress</h1>
      <p class="text-xl text-gray-700 mb-8 w-3/4">
        We are busy moving students to their next grades. Please be patient while this happens. You will be able to assign the students to their new classes once this is complete.
      </p>

      <div>
        <rl-icon
            :icon="'rl-spinning-gears'"
            :title="'rl spinning gears'"
            aria-hidden="true"
          />
      </div>

      <router-link
        to="/main/internal"
        class="px-4 p-2 text-gray-700 bg-white font-medium text-base rounded-full flex items-center shadow-lg mt-8"
      >
        <span class="h-5 w-4 [&>svg]:stroke-current [&>svg]:h-5 text-gray-700 me-2">
          <rl-icon
              :icon="'rl-small-back-arrow'"
              :title="'rl small back arrow'"
              aria-hidden="true"
          />
        </span>
        Back to Home
      </router-link>
    </div>
  </div>
</template>